import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField'
import data from "../../../assets/apiRoutes.json";
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";

import { GetFormatedDateWithTime,FormatPhoneNumber } from '../../../common/Utils'
import HeaderFrom from "../../common/HeaderFrom";
//import AdditionalTab from "../../wm/codes/customerDataEntry/AdditionalTab";
import UserDefinedTab from "./UserDefinedTab";
import AddressTab from "../../common/AddressTab";
import { custom } from 'devextreme/ui/dialog';
import AdditionalTab from "./AdditionalTab";
import ValidationSummary from 'devextreme-react/validation-summary';
import FMDefaultsTab from "./FMDefaultsTab";
import WMDefaultsTab from "./WMDefaultsTab";
import CreditTab from "./CreditTab";
import OMDefaultsTab from "./OMDefaultsTab";
import ArrayStore from 'devextreme/data/array_store';
import { v4 as uuidv4 } from 'uuid';
import HistoryTab from "./HistoryTab";
import SummaryTab from "./SummaryTab";
import MasterDataTab from "../../common/MasterDataTab";
import RelationshipLinkList from "../../common/lists/RelationshipLinkList";
import Synonym from "../../common/Synonym";
import AlternateAddressTab from "../../common/AlternateAddressTab";



var skipDataLoading = false;

function MainTab(props) {
   const initialFormFieldSummaryTotals = {
            
            invoiceMTD :0,
            invoiceYTD :0,
            invoiceLTD :0,
            invoicePriorY :0, 
            
            paymentMTD :0,
            paymentYTD :0,
            paymentLTD :0,
            paymentPriorY:0,
            
            discountMTD :0,
            discountYTD :0,
            discountLTD :0,
            discountPriorY :0,
            
            creditMTD :0,
            creditYTD :0,
            creditLTD :0,
            creditPriorY :0,
            
            paidMTD :0,
            paidYTD :0,
            paidLTD :0,
            paidPriorY :0,
            
            paidDueDateMTD :0,
            paidDueDateYTD :0,
            paidDueDateLTD :0,
            paidDueDatePrior:0,
            
            postedMTD :0,
            postedYTD :0,
            postedLTD :0,
            postedPriorY :0,
            
            paidLateMTD :0,
            paidLateYTD :0,
            paidLateLTD :0,
            paidLatePriorY :0,
            
            avgDaysPayMTD :0,
            avgDaysPayYTD :0,
            avgDaysPayLTD :0,
            avgDaysPayPriorY:0,
           
            CurrentBalance:0,
            LastStmBalance:0,
            LastStmDate:0, 
    };
   const initialFormFieldsHistoryTab ={
    TransactionDate:null,
    Amount:null,
    TransactionNumber:null,
    TransactionType:null,
    LastPaymentDate:null,
    LastPaymentAmount:null,
    LastPaymentReference:null,
    FinanceChargeDate :null,
    FinanceChargeAmount:null,
    YtdCharge:null,
    }
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: new Date(),
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: '',
        RECORDTYPE: '',
        IDENTITYID: '',
        NAME: '',
        R_DEFAULTADDRESS: null,
        INVISIBLETYPEGUID: '',
        R_PROFILE: null,
        PROFILEGUID: '',
        PROFILECODE: '',
        IDGROUP: '',
        IDSUBGROUP: '',
        REFERENCE1: '',
        REFERENCE2: '',
        DATE1: null,
        DATE2: null,
        R_CONTACT: null,
        COMMENT: '',
        CustomerCOMMENT: '',
        R_IDENTITY: null,
       
        AddressROWID: '00000000-0000-0000-0000-000000000000',
        AddressADDRESSNAME: '',
        AddressADDRESS1: '',
        AddressADDRESS2: '',
        AddressCITY: '',
        AddressZIP: '',
        AddressCOUNTRY: '',
        AddressTELEPHONE1: '',
        AddressTELEPHONE2: '',
        AddressFAX1: '',
        AddressFAX2: null,
        AddressMODEM1: '',
        AddressMODEM2: '',
        AddressCELLPHONE1: null,
        AddressCELLPHONE2: null,
        AddressPAGER1: null,
        AddressPAGER2: '',
        AddressEMAILADDRESS1: '',
        AddressEMAILADDRESS2: '',
        AddressWEBSITEADDRESS1: '',
        AddressWEBSITEADDRESS2: '',
        AddressSTATE: '',
        AddressALTERNATENAME: '',
        AddressLATITUDE: '',
        AddressLONGITUDE: '',
        AddressCOUNTY: '',
               
        AlterAddressROWID: '00000000-0000-0000-0000-000000000000',
        AlterAddressNAME:'',
        AlterAddressADDRESSNAME: '',
        AlterAddressADDRESS1: '',
        AlterAddressADDRESS2: '',
        AlterAddressCITY: '',
        AlterAddressZIP: '',
        AlterAddressCOUNTRY: '',
        AlterAddressTELEPHONE1: '',
        AlterAddressTELEPHONE2: '',
        AlterAddressFAX1: '',
        AlterAddressFAX2: null,
        AlterAddressMODEM1: '',
        AlterAddressMODEM2: '',
        AlterAddressCELLPHONE1: null,
        AlterAddressCELLPHONE2: null,
        AlterAddressPAGER1: null,
        AlterAddressPAGER2: '',
        AlterAddressEMAILADDRESS1: '',
        AlterAddressEMAILADDRESS2: '',
        AlterAddressWEBSITEADDRESS1: '',
        AlterAddressWEBSITEADDRESS2: '',
        AlterAddressSTATE: '',
        AlterAddressALTERNATENAME: '',
        AlterAddressLATITUDE: '',
        AlterAddressLONGITUDE: '',
        AlterAddressCOUNTY: '',
        DefAddress: true,

        CustomerSTATUS: 'A',
        CustomerR_TERMS: '',
        CustomerRESALENUMBER:'',
        CustomerSHIPSERVICECODE:'',
        CustomerLOTEXPIRATIONDATECHECK:'',
        CustomerSHIPSERVICEACCOUNT:'',
        CustomerR_GLDEPARTMENT:'',
        CustomerR_GLFUND:'',
        CustomerR_TAXCODE: '',
        CustomerR_TAXCODE2: '',
        CustomerOMPRINTBOL: 'Y',
        CustomerOMSENDFAX: 'Y',
        RECORD: '',
        CustomerROWID: '00000000-0000-0000-0000-000000000000',
        CustomerCREDITSTATUSFLAG:'',
        CustomerCREDITRATING:'',
        CustomerCREDITLIMIT:null,
        CustomerCREDITLASTREVIEWDATE:null,
        CustomerCREDITNEXTREVIEWDATE:null,
        CustomerDATEOPENED:null,
        CustomerLASTSTATEMENTBALANCE:null,
        CustomerCREDITCOMMENT:'',

        CustomerUSERDEFINEDCODE_1: '',
        CustomerUSERDEFINEDCODE_2: '',
        CustomerUSERDEFINEDCODE_3: '',
        CustomerUSERDEFINEDCODE_4: '',
        CustomerUSERDEFINEDCODE_5: '',
        CustomerUSERDEFINEDCODE_6: '',
        CustomerUSERDEFINEDCODE_7: '',
        CustomerUSERDEFINEDCODE_8: '',
        CustomerUSERDEFINEDCODE_9: '',
        CustomerUSERDEFINEDCODE_10: '',
        CustomerUSERDEFINEDREFERENCE_1: '',
        CustomerUSERDEFINEDREFERENCE_2: '',
        CustomerUSERDEFINEDREFERENCE_3: '',
        CustomerUSERDEFINEDREFERENCE_4: '',
        CustomerUSERDEFINEDREFERENCE_5: '',
        CustomerUSERDEFINEDREFERENCE_6: '',
        CustomerUSERDEFINEDREFERENCE_7: '',
        CustomerUSERDEFINEDREFERENCE_8: '',
        CustomerUSERDEFINEDREFERENCE_9: '',
        CustomerUSERDEFINEDREFERENCE_10: '',
        CustomerUSERDEFINEDDATE_1: null,
        CustomerUSERDEFINEDDATE_2: null,
        CustomerUSERDEFINEDDATE_3: null,
        CustomerUSERDEFINEDDATE_4: null,
        CustomerUSERDEFINEDDATE_5: null,
        CustomerUSERDEFINEDDATE_6: null,
        CustomerUSERDEFINEDDATE_7: null,
        CustomerUSERDEFINEDDATE_8: null,
        CustomerUSERDEFINEDDATE_9: null,
        CustomerUSERDEFINEDDATE_10: null,
        CustomerUSERDEFINEDCOMMENT: '',
        CustomerUSERDEFINEDQUANTITY_1: null,
        CustomerUSERDEFINEDQUANTITY_2: null,
        CustomerUSERDEFINEDQUANTITY_3: null,
        CustomerUSERDEFINEDQUANTITY_4: null,
        CustomerUSERDEFINEDQUANTITY_5: null,
        CustomerUSERDEFINEDQUANTITY_6: null,
        CustomerUSERDEFINEDQUANTITY_7: null,
        CustomerUSERDEFINEDQUANTITY_8: null,
        CustomerUSERDEFINEDQUANTITY_9: null,
        CustomerUSERDEFINEDQUANTITY_10: null,
        CustomerUSERDEFINEDCODE_11: '',
        CustomerUSERDEFINEDCODE_12: '',
        CustomerUSERDEFINEDCODE_13: '',
        CustomerUSERDEFINEDCODE_14: '',
        CustomerUSERDEFINEDCODE_15: '',
        CustomerUSERDEFINEDCODE_16: '',
        CustomerUSERDEFINEDCODE_17: '',
        CustomerUSERDEFINEDCODE_18: '',
        CustomerUSERDEFINEDCODE_19: '',
        CustomerUSERDEFINEDCODE_20: '',
        CustomerUSERDEFINEDDATE_11: null,
        CustomerUSERDEFINEDDATE_12: null,
        CustomerUSERDEFINEDDATE_13: null,
        CustomerUSERDEFINEDDATE_14: null,
        CustomerUSERDEFINEDDATE_15: null,
        CustomerUSERDEFINEDDATE_16: null,
        CustomerUSERDEFINEDDATE_17: null,
        CustomerUSERDEFINEDDATE_18: null,
        CustomerUSERDEFINEDDATE_19: null,
        CustomerUSERDEFINEDDATE_20: null,
        CustomerUSERDEFINEDQUANTITY_11: null,
        CustomerUSERDEFINEDQUANTITY_12: null,
        CustomerUSERDEFINEDQUANTITY_13: null,
        CustomerUSERDEFINEDQUANTITY_14: null,
        CustomerUSERDEFINEDQUANTITY_15: null,
        CustomerUSERDEFINEDQUANTITY_16: null,
        CustomerUSERDEFINEDQUANTITY_17: null,
        CustomerUSERDEFINEDQUANTITY_18: null,
        CustomerUSERDEFINEDQUANTITY_19: null,
        CustomerUSERDEFINEDQUANTITY_20: null,
        CustomerUSERDEFINEDREFERENCE_11: '',
        CustomerUSERDEFINEDREFERENCE_12: '',
        CustomerUSERDEFINEDREFERENCE_13: '',
        CustomerUSERDEFINEDREFERENCE_14: '',
        CustomerUSERDEFINEDREFERENCE_15: '',
        CustomerUSERDEFINEDREFERENCE_16: '',
        CustomerUSERDEFINEDREFERENCE_17: '',
        CustomerUSERDEFINEDREFERENCE_18: '',
        CustomerUSERDEFINEDREFERENCE_19: '',
        CustomerUSERDEFINEDREFERENCE_20: '',
        CustomerARACCOUNT: '',
        CustomerR_AROPENITEMDP: '',
        CustomerR_CASHRECEIPTSPORFILE: '',
        CustomerSETTLEMENTPAYGROUP: '',
        CustomerSMINVOICEEMAIL: 'N',
        CustomerR_TRADINGPARTNER:'',
        CustomerSCAC:'',
        CustomerR_SERVICESPRICING:'',
        CustomerPOPUPMESSAGE:'',
        CustomerBILLINGCYCLE:'',
        CustomerSHIPSERVICELEVEL:'A',
        
        CustomerR_WMDEFAULTTRANSPROFILE :'',
        CustomerR_WMSHIPMENTPROFILE :'',
        CustomerR_WMADJUSTMENTPROFILE :'',
        CustomerR_WMRATESCHEDULE :'',
        CustomerR_WMDEFAULTITEMPROFILE :'',
        CustomerR_FMDEFAULTTRANSPROFILE :'',
        CustomerWMRICCONSOLIDATIONFLAG :'C',
        CustomerWMSICCONSOLIDATIONFLAG :'C',
        CustomerWMAICCONSOLIDATIONFLAG :'C',
        CustomerWMCICCONSOLIDATIONFLAG :'C',
        CustomerWMRICFREQUENCY :'',
        CustomerWMSICFREQUENCY :'',
        CustomerWMAICFREQUENCY :'',
        CustomerWMCICFREQUENCY :'',
        CustomerWMRTCCONSOLIDATIONFLAG  :'C',
        CustomerWMSTCCONSOLIDATIONFLAG :'C',
        CustomerWMATCCONSOLIDATIONFLAG :'C',
        CustomerWMCTCCONSOLIDATIONFLAG :'C',
        CustomerWMRTCFREQUENCY :'',
        CustomerWMSTCFREQUENCY :'',
        CustomerWMATCFREQUENCY :'',
        CustomerWMCTCFREQUENCY :'',
        CustomerWMSHIPMENTSERIALNOPREFIX :'',
        CustomerWMVICSBOLNOPREFIX :'',
        CustomerMINIMUMDAILYCHARGE :null,
        CustomerFREQUENCYCODE :'',
        CustomerR_EVALUATIONEXPCODE :'',
        CustomerWMMTCFREQUENCY:'',
        CustomerWMMTCCONSOLIDATIONFLAG:'C',
        CustomerR_FMDEFAULTDOPROFILE:'',
        CustomerR_FMFREIGHTCHARGE:'',
        CustomerR_FMFREIGHTCODE:'',
        CustomerFMCONSOLIDATEDINVOICE:'',
        CustomerBOLREQUIREMENTFLAG:'',
        CustomerPOREQUIREMENTFLAG:'',
        CustomerFMINVOICECOMMITFLAG:'',
        CustomerFMAROPENITEMDESC:'',
        CustomerR_RATESCHEDULE:'',
        CustomerFMWEIGHTBASE:'',
        CustomerR_FMBATCHPRINT:'',
        CustomerFMDEFAULTMILESCALCULATIONBASIS:'',
        CustomerFMPAYMILEAGEAPP:'',
        CustomerLIMIT53TRL:'',
        CustomerSOINVENTORYPRICELEVEL : 'A',
        CustomerR_PRICESHEDULE : '',
        CustomerNORMALOPENDAYS : null,
        CustomerPARTIALSHIPMENT : 'Y',
        CustomerR_OMDEFAULTTRANSPROFILE : '',
        CustomerR_DEFAULTSHIPTO : '',
        CustomerTAXCODESOURCE : 'P',
        CustomerOMREQUIREPO : 'N',
        CustomerCREDITOMORDERS : '',
        CustomerPAYMENTPROFILE : '',
        CustomerOMPRINTPICKSLIP : 'Y',
        CustomerOMPRINTORDERACKNOWLEDGEMENT : 'Y',
        CustomerOMPRINTDELIVERYNOTIFICATION : 'Y',
        CustomerOMPRINTPACKINGSLIP : 'Y',
        CustomerOMPRINTINVOICE : 'Y',
        CustomerOMPRINTBOL : 'Y',
        CustomerOMSENDFAX : 'N',
        CustomerOMSENDEMAIL : 'N',
        CustomerOMPICKINGSLIPREPORTTYPE : 'A',
        CustomerOMINVOICEREPORTTYPE : 'A',
        CustomerOMORDERACKNREPORTTYPE : 'A',
        CustomerCUSTOMERPURCHASEDISCOUNT : 0,
        CustomerDISCOUNTTYPE : '',
        CustomerR_DISCOUNTTABLE : '',
        CustomerIMCRGROUP : '',
        CustomerPAYMENTSYSTEM : 'N',
        CustomerPAYMENTTHRESHOLD : null,
        CustomerOMDEFAULTREPORTFORMATS:'',
        CustomerLASTSTATEMENTDATE:null,
        CustomerLASTSTATEMENTBALANCE:null,
    };
    const history = useHistory();
    const location = useLocation();
        const IdType ="01";
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const [formFieldSummaryTotals, setformFieldSummaryTotals] = useState(initialFormFieldSummaryTotals);

    const [omDefaultRef, setOmDefaultRef] = useState(null);
    const [reportFormats, setReportFormats] = useState({pickingSlipFormat:'',InvoiceFormat:'',OrderAcknFormat:''});
   
    const [customerFinancialInfo, setCustomerFinancialInfo ]=useState(initialFormFieldsHistoryTab);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    let customerId=null;
    let addressId=null;
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await postTransaction();
            }
            else {
                await updateTransaction();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const postTransaction = async () => {
        try {
            const url = "id/Customer/InsertCustomerDataEntry";
            let fields = formFields;
            fields.DefAddress=fields.DefAddress??true;
            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.CustomerCREDITLASTREVIEWDATE = GetFormatedDateWithTime(formFields.CustomerCREDITLASTREVIEWDATE);
            fields.CustomerCREDITNEXTREVIEWDATE = GetFormatedDateWithTime(formFields.CustomerCREDITNEXTREVIEWDATE);
            fields.CustomerDATEOPENED = GetFormatedDateWithTime(formFields.CustomerDATEOPENED);
            fields.CustomerOMDEFAULTREPORTFORMATS = getFormats();
            fields.RECORDTYPE='R';
            fields.CustomerUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_1);
            fields.CustomerUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_2);
            fields.CustomerUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_3);
            fields.CustomerUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_4);
            fields.CustomerUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_5);
            fields.CustomerUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_6);
            fields.CustomerUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_7);
            fields.CustomerUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_8);
            fields.CustomerUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_9);
            fields.CustomerUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_10);
            fields.CustomerUSERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_11);
            fields.CustomerUSERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_12);
            fields.CustomerUSERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_13);
            fields.CustomerUSERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_14);
            fields.CustomerUSERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_15);
            fields.CustomerUSERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_16);
            fields.CustomerUSERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_17);
            fields.CustomerUSERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_18);
            fields.CustomerUSERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_19);
            fields.CustomerUSERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_20);
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                addressId = response.data.AddressROWID;
                customerId =  response.data.EntityROWID;
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD,
                    AddressROWID: response.data.AddressROWID,
                    R_DEFAULTADDRESS: response.data.AddressROWID,
                    CustomerROWID: response.data.EntityROWID,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                if(typeof props.refreshDynamicLookup === 'function'){
                    props.refreshDynamicLookup(response.data.ROWID,formFields.IDENTITYID);
                }
                notify(
                    {
                        message: "Customer Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            const url = "id/Customer/UpdateCustomerDataEntry";
            let fields = formFields;
            fields.DefAddress=fields.DefAddress??true;
            if(fields.AlterAddressROWID===null)
             fields.AlterAddressROWID=initialFormFields.AlterAddressROWID;

            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.CustomerCREDITLASTREVIEWDATE = GetFormatedDateWithTime(formFields.CustomerCREDITLASTREVIEWDATE);
            fields.CustomerCREDITNEXTREVIEWDATE = GetFormatedDateWithTime(formFields.CustomerCREDITNEXTREVIEWDATE);
            fields.CustomerDATEOPENED = GetFormatedDateWithTime(formFields.CustomerDATEOPENED);
            fields.CustomerOMDEFAULTREPORTFORMATS = getFormats();

            fields.CustomerUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_1);
            fields.CustomerUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_2);
            fields.CustomerUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_3);
            fields.CustomerUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_4);
            fields.CustomerUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_5);
            fields.CustomerUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_6);
            fields.CustomerUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_7);
            fields.CustomerUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_8);
            fields.CustomerUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_9);
            fields.CustomerUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_10);
            fields.CustomerUSERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_11);
            fields.CustomerUSERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_12);
            fields.CustomerUSERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_13);
            fields.CustomerUSERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_14);
            fields.CustomerUSERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_15);
            fields.CustomerUSERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_16);
            fields.CustomerUSERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_17);
            fields.CustomerUSERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_18);
            fields.CustomerUSERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_19);
            fields.CustomerUSERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.CustomerUSERDEFINEDDATE_20);

            if(addressId!==null){fields.AddressROWID=addressId;}
            if(customerId!==null){fields.CustomerROWID=customerId;}

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0)  {
                setformFields(prevFields => ({
                    ...prevFields,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Customer Data Entry Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad =(formRefs) => {
        primaryFormLoad(formRefs);
        additionalFormLookupsLoad(formRefs);
        userDefinedFormLookupsLoad(formRefs);
        fmDefaultsFormLookupsLoad(formRefs);
        wmDefaultsFormLookupsLoad(formRefs);

        historyFormLoaded(formRefs);
        omDefaultsFormLookupsLoad(formRefs);
        summaryFormLoaded(formRefs);
    }
    const additionalFormLookupsLoad =(formRefs) => {
        const groupLoadParams = {
            codeType: '01',
        };
        const settlementgroupLoadParams = {
            codeType: 'AC',
        };
        const serviceParams = {
            codeType: 'PS',
        };
        loadLookupFromDataSource(formRefs,"CustomerR_TERMS", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTerms}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_TAXCODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTax}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_TAXCODE2", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTax}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerBILLINGCYCLE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',groupLoadParams);
        loadLookupFromDataSource(formRefs,"CustomerR_GLDEPARTMENT", `${window._env_.REACT_APP_APIS}/${data.AC.GetDepartments}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_GLFUND", `${window._env_.REACT_APP_APIS}/${data.FA.GetFafunds}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_CAJOB", `${window._env_.REACT_APP_APIS}/${data.CA.GetCaJobs}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_TRADINGPARTNER", `${window._env_.REACT_APP_APIS}/${data.ID.GetTradePartner}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_SERVICESPRICING", `${window._env_.REACT_APP_APIS}/${data.ID.GetServicePricing}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerPOPUPMESSAGE", `${window._env_.REACT_APP_APIS}/${data.AB.GetPopupMessages}`,'name','name');
        loadLookupFromDataSource(formRefs,"CustomerSETTLEMENTPAYGROUP", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',settlementgroupLoadParams);
        loadLookupFromDataSource(formRefs,"CustomerR_CASHRECEIPTSPORFILE", `${window._env_.REACT_APP_APIS}/${data.AR.GetArCashReceiptsDp}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerARACCOUNT", `${window._env_.REACT_APP_APIS}/${data.AC.GetAcAccounts}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerSHIPSERVICECODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',serviceParams);

        loadLookupFromStaticData(formRefs,"CustomerLOTEXPIRATIONDATECHECK",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerSHIPSERVICELEVEL",[{id:'A',name:"Autodetect"},{id:'B',name:"Ship Crates"},{id:'C',name:"Ship Serial numbers"},{id:'D',name:"Ship Sublots"}]);
        loadLookupFromStaticData(formRefs,"CustomerSTATUS",[{id:'A',name:"Active"},{id:'I',name:"Inactive"}]);
        loadLookupFromStaticData(formRefs,"CustomerSMINVOICEEMAIL",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromDataSource(formRefs,"CustomerR_AROPENITEMDP", `${window._env_.REACT_APP_APIS}/${data.AR.GetArOpenItemDp}`,'id','name');


    };
    const userDefinedFormLookupsLoad = (formRefs) => {
            loadLookupFromCodesDataSource(formRefs,'07', 'CustomerUSERDEFINEDCODE_1')
            loadLookupFromCodesDataSource(formRefs,'08', 'CustomerUSERDEFINEDCODE_2')
            loadLookupFromCodesDataSource(formRefs,'09', 'CustomerUSERDEFINEDCODE_3')
            loadLookupFromCodesDataSource(formRefs,'10', 'CustomerUSERDEFINEDCODE_4')
            loadLookupFromCodesDataSource(formRefs,'11', 'CustomerUSERDEFINEDCODE_5')
            loadLookupFromCodesDataSource(formRefs,'12', 'CustomerUSERDEFINEDCODE_6')
            loadLookupFromCodesDataSource(formRefs,'13', 'CustomerUSERDEFINEDCODE_7')
            loadLookupFromCodesDataSource(formRefs,'14', 'CustomerUSERDEFINEDCODE_8')
            loadLookupFromCodesDataSource(formRefs,'15', 'CustomerUSERDEFINEDCODE_9')
            loadLookupFromCodesDataSource(formRefs,'16', 'CustomerUSERDEFINEDCODE_10')
            loadLookupFromCodesDataSource(formRefs,'3B', 'CustomerUSERDEFINEDCODE_11')
            loadLookupFromCodesDataSource(formRefs,'3C', 'CustomerUSERDEFINEDCODE_12')
            loadLookupFromCodesDataSource(formRefs,'3D', 'CustomerUSERDEFINEDCODE_13')
            loadLookupFromCodesDataSource(formRefs,'3E', 'CustomerUSERDEFINEDCODE_14')
            loadLookupFromCodesDataSource(formRefs,'3F', 'CustomerUSERDEFINEDCODE_15')
            loadLookupFromCodesDataSource(formRefs,'3G', 'CustomerUSERDEFINEDCODE_16')
            loadLookupFromCodesDataSource(formRefs,'3H', 'CustomerUSERDEFINEDCODE_17')
            loadLookupFromCodesDataSource(formRefs,'3I', 'CustomerUSERDEFINEDCODE_18')
            loadLookupFromCodesDataSource(formRefs,'3J', 'CustomerUSERDEFINEDCODE_19')
            loadLookupFromCodesDataSource(formRefs,'3K', 'CustomerUSERDEFINEDCODE_20')
    };
    const primaryFormLoad=(formRefs)=>{
        const idprofilesLoadParams = {
            codeType: '22',
        };
        const groupLoadParams = {
            codeType: 'Z7',
        };
        const subgroupLoadParams = {
            codeType: 'Z8',
        };
        const settlementgroupLoadParams = {
            codeType: 'AC',
        };
        const serviceParams = {
            codeType: 'PS',
        };
        //loadLookupFromDataSource(formRefs,"R_PROFILE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDProfiles}`,'id','name',idprofilesLoadParams);
       // loadLookupFromDataSource(formRefs,"R_CONTACT", `${window._env_.REACT_APP_APIS}/${data.ID.GetContacts}`,'id','name',idprofilesLoadParams);
       // loadLookupFromDataSource(formRefs,"IDGROUP", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',groupLoadParams);
        //loadLookupFromDataSource(formRefs,"IDSUBGROUP", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',subgroupLoadParams);
        loadLookupFromDataSource(formRefs,"CustomerARACCOUNT", `${window._env_.REACT_APP_APIS}/${data.AC.GetAcAccounts}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_CASHRECEIPTSPORFILE", `${window._env_.REACT_APP_APIS}/${data.AR.GetArCashReceiptsDp}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerSETTLEMENTPAYGROUP", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',settlementgroupLoadParams);
        loadLookupFromStaticData(formRefs,"CustomerSMINVOICEEMAIL",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);

        loadLookupFromDataSource(formRefs,"CustomerR_TERMS", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTerms}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_TAXCODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTax}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_TAXCODE2", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTax}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerBILLINGCYCLE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',groupLoadParams);
        loadLookupFromDataSource(formRefs,"CustomerR_GLDEPARTMENT", `${window._env_.REACT_APP_APIS}/${data.AC.GetDepartments}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_GLFUND", `${window._env_.REACT_APP_APIS}/${data.FA.GetFafunds}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_CAJOB", `${window._env_.REACT_APP_APIS}/${data.CA.GetCaJobs}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_TRADINGPARTNER", `${window._env_.REACT_APP_APIS}/${data.ID.GetTradePartner}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_SERVICESPRICING", `${window._env_.REACT_APP_APIS}/${data.ID.GetServicePricing}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerPOPUPMESSAGE", `${window._env_.REACT_APP_APIS}/${data.AB.GetPopupMessages}`,'name','name');
        loadLookupFromDataSource(formRefs,"CustomerSHIPSERVICECODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,'name','name',serviceParams);
       
        loadLookupFromStaticData(formRefs,"CustomerLOTEXPIRATIONDATECHECK",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerSHIPSERVICELEVEL",[{id:'A',name:"Auto Detect"},{id:'B',name:"Ship Create"},{id:'C',name:"Ship Serial Number"},{id:'D',name:"Ship Sublots"}]);
        loadLookupFromStaticData(formRefs,"CustomerSTATUS",[{id:'A',name:"Active"},{id:'I',name:"Inactive"}]);

        loadLookupFromCodesDataSource(formRefs,'07', 'CustomerUSERDEFINEDCODE_1')
        loadLookupFromCodesDataSource(formRefs,'08', 'CustomerUSERDEFINEDCODE_2')
        loadLookupFromCodesDataSource(formRefs,'09', 'CustomerUSERDEFINEDCODE_3')
        loadLookupFromCodesDataSource(formRefs,'10', 'CustomerUSERDEFINEDCODE_4')
        loadLookupFromCodesDataSource(formRefs,'11', 'CustomerUSERDEFINEDCODE_5')
        loadLookupFromCodesDataSource(formRefs,'12', 'CustomerUSERDEFINEDCODE_6')
        loadLookupFromCodesDataSource(formRefs,'13', 'CustomerUSERDEFINEDCODE_7')
        loadLookupFromCodesDataSource(formRefs,'14', 'CustomerUSERDEFINEDCODE_8')
        loadLookupFromCodesDataSource(formRefs,'15', 'CustomerUSERDEFINEDCODE_9')
        loadLookupFromCodesDataSource(formRefs,'16', 'CustomerUSERDEFINEDCODE_10')
        loadLookupFromCodesDataSource(formRefs,'3B', 'CustomerUSERDEFINEDCODE_11')
        loadLookupFromCodesDataSource(formRefs,'3C', 'CustomerUSERDEFINEDCODE_12')
        loadLookupFromCodesDataSource(formRefs,'3D', 'CustomerUSERDEFINEDCODE_13')
        loadLookupFromCodesDataSource(formRefs,'3E', 'CustomerUSERDEFINEDCODE_14')
        loadLookupFromCodesDataSource(formRefs,'3F', 'CustomerUSERDEFINEDCODE_15')
        loadLookupFromCodesDataSource(formRefs,'3G', 'CustomerUSERDEFINEDCODE_16')
        loadLookupFromCodesDataSource(formRefs,'3H', 'CustomerUSERDEFINEDCODE_17')
        loadLookupFromCodesDataSource(formRefs,'3I', 'CustomerUSERDEFINEDCODE_18')
        loadLookupFromCodesDataSource(formRefs,'3J', 'CustomerUSERDEFINEDCODE_19')
        loadLookupFromCodesDataSource(formRefs,'3K', 'CustomerUSERDEFINEDCODE_20')
        
        if(formRefs.current['RECORD']){
        formRefs.current['RECORD'].instance().option('disabled', true);
        }
    }
    const fmDefaultsFormLookupsLoad =(formRefs)=>{
        const fmcodesLoadParams = {
            codeType: '39',
        };
        const mileages = [{ id: 'P', name: "Practical" }, { id: 'Q', name: "Practical + Closed Borders" }, { id: '1', name: "Practical + Avoid Toll" }, { id: '7', name: "Practical + Avoid Toll + Closed Borders" }, { id: '2', name: "Practical + National" }, { id: '8', name: "Practical + National + Closed Borders" }, { id: '3', name: "Practical + Avoid Toll + National" },
            { id: '9', name: "Practical + Avoid Toll + National + Closed Borders" }, { id: 'S', name: "Shortest" }, { id: 'T', name: "Shortest + Closed Borders" }, { id: '4', name: "Shortest + Avoid Toll" }, { id: 'X', name: "Shortest + Avoid Toll + Closed Border" },
            { id: '5', name: "Shortest + National" }, { id: 'Y', name: "Shortest + National + Closed Border" }, { id: '6', name: "Shortest + Avoid Toll + National" }, { id: 'Z', name: "Shortest + Avoid Toll + National + Closed Borders" }, { id: 'G', name: "Commercial w/o Restriction & Borders Open (Prophesy Only)" },
            { id: 'H', name: "Commercial w/o Restrictions & Borders Closed (Prophesy Only)" }, { id: 'I', name: "Commercial w/ Restrictions & Borders Open (Prophesy Only)" }, { id: 'J', name: "Commercial w/ Restrictions & Borders Closed (Prophesy Only)" },{ id: 'K', name: "HHG (Rand-McNally Only)" },
            { id: 'L', name: "HHG with Borders Closed (Rand-McNally Only)" },{ id: 'M', name: "Quickest (Rand-McNally Only)" },{ id: 'N', name: "Quickest with Borders Closed (Rand-McNally)" },{ id: 'O', name: "Lowest Cost (Rand-McNally Only)" },{ id: 'R', name: "Lowest Cost with Borders Closed (Rand-McNally Only)" }
            ]
        loadLookupFromDataSource(formRefs,"CustomerR_FMDEFAULTTRANSPROFILE", `${window._env_.REACT_APP_APIS}/fm/Lookup/GetFmprofiles`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_FMDEFAULTDOPROFILE", `${window._env_.REACT_APP_APIS}/fm/Lookup/GetFmprofilesdispatch`, 'id', 'name');
        loadLookupFromDataSource(formRefs,"CustomerR_FMFREIGHTCHARGE", `${window._env_.REACT_APP_APIS}/${data.ID.GetFreightCharges}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_FMFREIGHTCODE", `${window._env_.REACT_APP_APIS}/${data.RT.GetRTFreightClass}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerFMCONSOLIDATEDINVOICE", `${window._env_.REACT_APP_APIS}/fm/Lookup/GetFmcodes`,'name','name',fmcodesLoadParams);
        loadLookupFromDataSource(formRefs,"CustomerR_FMBATCHPRINT", `${window._env_.REACT_APP_APIS}/${data.ID.GetBatchPrintHeader}`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_RATESCHEDULE", `${window._env_.REACT_APP_APIS}/${data.ID.GetFreightRateScheduler}`,'id','name');
        loadLookupFromStaticData(formRefs,"CustomerBOLREQUIREMENTFLAG",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerPOREQUIREMENTFLAG",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerFMINVOICECOMMITFLAG",[{id:'D',name:"FB Details"},{id:'I',name:"Invoice"}]);
        loadLookupFromStaticData(formRefs,"CustomerFMAROPENITEMDESC",[{id:'D',name:"Freight Bill Description"},{id:'P',name:"Freight Bill PO/Reference"},{id:'B',name:"Freight Bill Bll of Lading"}]);
        loadLookupFromStaticData(formRefs,"CustomerFMWEIGHTBASE",[{id:'N',name:"None"},{id:'O',name:"From Origin"},{id:'D',name:"From Destination"}]);

        loadLookupFromStaticData(formRefs,"CustomerFMDEFAULTMILESCALCULATIONBASIS",mileages);
        loadLookupFromStaticData(formRefs,"CustomerFMPAYMILEAGEAPP",[{id:'N',name:"None"},{id:'P',name:"PC Miler versions 14-33"},{id:'T',name:"PC Miler Streets v16-33 (DLL)"},{id:'S',name:"PC Miler Streets versions 3-4"}
            ,{id:'R',name:"Rand McNally"},{id:'O',name:"Prophesy (Windows 8.2.02)"},{id:'D',name:"PC Miler v26.0.4-33 (DLL)"},{id:'4',name:"PC Miler v34-38+"},{id:'5',name:"PC Miler Streets v34-38+"}
        ]);
        loadLookupFromStaticData(formRefs,"CustomerLIMIT53TRL",[{id:'A',name:"Always Perform 5'3 Trailer Routing"},{id:'N',name:"Never Perform 5'3 Trailer Routing"},{id:'C',name:"Check Trailer Length for 5'3 Trailer Routing"}]);

    }
    const omDefaultsFormLookupsLoad =(formRefs)=>{
        const priceLevels=[{id:'A',name:"Price Level - A"},{id:'B',name:"Price Level - B"},{id:'C',name:"Price Level - C"},{id:'D',name:"Price Level - D"},{id:'E',name:"Price Level - E"},
            {id:'F',name:"Price Level - F"},{id:'G',name:"Price Level - G"},{id:'H',name:"Price Level - H"},{id:'I',name:"Price Level - I"},{id:'J',name:"Price Level - J"},{id:'K',name:"Price Level - K"},{id:'L',name:"Price Level - L"},{id:'M',name:"Price Level - M"},
            {id:'N',name:"Price Level - N"},{id:'O',name:"Price Level - O"},{id:'P',name:"Price Level - P"},{id:'Q',name:"Price Level - Q"},{id:'R',name:"Price Level - R"},
            {id:'S',name:"Price Level - S"},{id:'T',name:"Price Level - T"},{id:'U',name:"Price Level - U"},{id:'V',name:"Price Level - V"},{id:'X',name:"Price Level - X"},
            {id:'Y',name:"Price Level - Y"},{id:'Z',name:"Price Level - Z"}
        ];
        const reportTypes=[{id:'A',name:"From OM Profile"},{id:'B',name:"Insight 8 Report"},{id:'C',name:"ART Report"}];

        loadLookupFromDataSource(formRefs,"CustomerR_PRICESHEDULE", `${window._env_.REACT_APP_APIS}/im/Lookup/GetPriceScheduale`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_OMDEFAULTTRANSPROFILE", `${window._env_.REACT_APP_APIS}/om/Lookup/GetProfiles`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerR_DEFAULTSHIPTO", `${window._env_.REACT_APP_APIS}/id/Lookup/GetShipTo`,'id','name',{rowid:props?.id});
        loadLookupFromDataSource(formRefs,"CustomerR_DISCOUNTTABLE", `${window._env_.REACT_APP_APIS}/id/Lookup/GetDiscountHeader`,'id','name');
        loadLookupFromDataSource(formRefs,"CustomerIMCRGROUP", `${window._env_.REACT_APP_APIS}/id/Lookup/GetIDCodes`,'name','name',{codeType:'Z5'});

        loadLookupFromStaticData(formRefs,"CustomerSOINVENTORYPRICELEVEL",priceLevels);
        loadLookupFromStaticData(formRefs,"CustomerPARTIALSHIPMENT",[{id:'Y',name:"Yes, Partial Shipment"},{id:'N',name:"No, Partial Shipment"}]);
        loadLookupFromStaticData(formRefs,"CustomerTAXCODESOURCE",[{id:'P',name:"Select tax based on OM profile"},{id:'C',name:"Always use customer's tax code"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMREQUIREPO",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        
        loadLookupFromStaticData(formRefs,"CustomerOMINVOICEREPORTTYPE",reportTypes);
        loadLookupFromStaticData(formRefs,"CustomerOMPICKINGSLIPREPORTTYPE",reportTypes);
        loadLookupFromStaticData(formRefs,"CustomerOMORDERACKNREPORTTYPE",reportTypes);

        loadLookupFromStaticData(formRefs,"CustomerCREDITOMORDERS",[{id:'N',name:"Pending - Effect Net Available"},{id:'A',name:"Assigned - Effect Available"}]);

        loadLookupFromStaticData(formRefs,"CustomerOMPRINTPICKSLIP",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMPRINTORDERACKNOWLEDGEMENT",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMPRINTDELIVERYNOTIFICATION",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMPRINTPACKINGSLIP",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMPRINTINVOICE",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMPRINTBOL",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMSENDFAX",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        loadLookupFromStaticData(formRefs,"CustomerOMSENDEMAIL",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);

        loadLookupFromStaticData(formRefs,"CustomerDISCOUNTTYPE",[{id:'Y',name:"None"},{id:'I',name:"Item Discount"},{id:'T',name:"Total Discount"}
            ,{id:'B',name:"Both Item & Total Discount"},{id:'D',name:"Discount Table"},{id:'P',name:"Transaction Profile"}
        ]);
        loadLookupFromStaticData(formRefs,"CustomerPAYMENTSYSTEM",[{id:'Y',name:"Yes"},{id:'N',name:"No"}]);
        setOmDefaultRef(formRefs);
    }
    useEffect(() => {
        if(omDefaultRef){
            oMDefaultsSelectionChanged(omDefaultRef,'CustomerOMPICKINGSLIPREPORTTYPE',formFields.CustomerOMPICKINGSLIPREPORTTYPE);
            oMDefaultsSelectionChanged(omDefaultRef,'CustomerOMINVOICEREPORTTYPE',formFields.CustomerOMINVOICEREPORTTYPE);
            oMDefaultsSelectionChanged(omDefaultRef,'CustomerOMORDERACKNREPORTTYPE',formFields.CustomerOMORDERACKNREPORTTYPE);
            oMDefaultsSelectionChanged(omDefaultRef,'CustomerDISCOUNTTYPE',formFields.CustomerDISCOUNTTYPE);
            extractNames();

        }
      }, [omDefaultRef,formFields.CustomerOMPICKINGSLIPREPORTTYPE,formFields.CustomerOMINVOICEREPORTTYPE,formFields.CustomerOMORDERACKNREPORTTYPE,formFields.CustomerDISCOUNTTYPE]);
    const wmDefaultsFormLookupsLoad=(formRefs)=>{
        const freqCodes = {
            codeType: 'W1',
        };
        const ConsolidatedLookup = [{ id: 'T', name: 'By Transaction' }, { id: 'C', name: 'Consolidated Details By Customer' }, { id: 'K', name: 'Consolidated By Customer and Shipper #' }, { id: 'M', name: 'Consolidated By Customer and Management Units' }]
        const ConsolidatedLookup2 = [{ id: 'T', name: 'By Transaction' }, { id: 'C', name: 'Consolidated Details By Customer' }, { id: 'M', name: 'Consolidated By Customer and Management Units' }]

        loadLookupFromDataSource(formRefs,"CustomerR_WMDEFAULTTRANSPROFILE", `${window._env_.REACT_APP_APIS}/${data.WMLookup.TransactionDP}`, 'id', 'name');
        loadLookupFromDataSource(formRefs,"CustomerR_WMSHIPMENTPROFILE", `${window._env_.REACT_APP_APIS}/${data.WMLookup.TransactionDP}`, 'id', 'name');
        loadLookupFromDataSource(formRefs,"CustomerR_WMADJUSTMENTPROFILE", `${window._env_.REACT_APP_APIS}/${data.WMLookup.TransactionDP}`, 'id', 'name');
        loadLookupFromDataSource(formRefs,"CustomerR_WMDEFAULTITEMPROFILE", `${window._env_.REACT_APP_APIS}/${data.IM.ItemDP}`, 'id', 'name');

        loadLookupFromDataSource(formRefs,"CustomerR_WMRATESCHEDULE", `${window._env_.REACT_APP_APIS}/${data.WMLookup.WMRateSchedule}`, 'id', 'name');
        loadLookupFromDataSource(formRefs,"CustomerR_EVALUATIONEXPCODE", `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetWMEvaluationExpression}`, 'id', 'name');

        loadLookupFromDataSource(formRefs,"CustomerWMRICFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMSICFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMAICFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMCICFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);

        loadLookupFromDataSource(formRefs,"CustomerWMRTCFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMSTCFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMATCFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMCTCFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);
        loadLookupFromDataSource(formRefs,"CustomerWMMTCFREQUENCY", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);


        loadLookupFromDataSource(formRefs,"CustomerFREQUENCYCODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', freqCodes);

        loadLookupFromStaticData(formRefs,"CustomerWMRICCONSOLIDATIONFLAG", ConsolidatedLookup);
        loadLookupFromStaticData(formRefs,"CustomerWMSICCONSOLIDATIONFLAG", ConsolidatedLookup);
        loadLookupFromStaticData(formRefs,"CustomerWMAICCONSOLIDATIONFLAG", ConsolidatedLookup2);
        loadLookupFromStaticData(formRefs,"CustomerWMCICCONSOLIDATIONFLAG", ConsolidatedLookup2);

        loadLookupFromStaticData(formRefs,"CustomerWMRTCCONSOLIDATIONFLAG", ConsolidatedLookup);
        loadLookupFromStaticData(formRefs,"CustomerWMSTCCONSOLIDATIONFLAG", ConsolidatedLookup);
        loadLookupFromStaticData(formRefs,"CustomerWMATCCONSOLIDATIONFLAG", ConsolidatedLookup2);
        loadLookupFromStaticData(formRefs,"CustomerWMCTCCONSOLIDATIONFLAG", ConsolidatedLookup2);
        loadLookupFromStaticData(formRefs,"CustomerWMMTCCONSOLIDATIONFLAG", ConsolidatedLookup2);


        if (formRefs.current["MiscConsolidated"]) {
            formRefs.current["MiscConsolidated"].instance().option('disabled', true);
        }
        if (formRefs.current["MiscFrq"]) {
            formRefs.current["MiscFrq"].instance().option('disabled', true);
        }
    }
    const creditFormLookupsLoad = (formRefs)=>{
        const creditCodes = {
            codeType: 'ZZ',
        };
        const statuses = [{ id: 'N', name: 'Not Required/Open' }, { id: 'A', name: 'Reviewed and Approved' }, { id: 'P', name: 'Review Pending' }, { id: 'R', name: 'Review Required' },
            { id: 'C', name: 'COD' }, { id: 'H', name: 'Hold/Orders not Allowed' }
        ]

        loadLookupFromDataSource(formRefs,"CustomerCREDITRATING", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', creditCodes);
        loadLookupFromStaticData(formRefs,"CustomerCREDITSTATUSFLAG", statuses);
    }
   const historyFormLoaded = async (formRefs)=>{
    let data=initialFormFieldsHistoryTab;
    const hasAnyControl = Object.keys(initialFormFieldsHistoryTab).some(
        (key) => formRefs.current[key]?.instance !== undefined
      );
    if(hasAnyControl && props.id!=='' && props.id!==null &&  props.id!==undefined){
         data=await fetchCustomerFinanacialInfo(props.id);
    }
    Object.entries(data).forEach(([key, value]) => {
        if (formRefs.current[key]) {
          formRefs.current[key].instance().option('value', value);
          formRefs.current[key].instance().option('disabled', true);
        }
      });

    }
    const summaryFormLoaded = async (formRefs)=>{
        const hasAnyControl = Object.keys(initialFormFieldSummaryTotals).some(
            (key) => formRefs.current[key]?.instance !== undefined
          );
        if(hasAnyControl && props.id!=='' && props.id!==null &&  props.id!==undefined){
            const totals =await fetchSummaryTotalsData(props.id);
            mapSummaryTotals(formRefs,totals);
        }
        else{
            mapSummaryTotals(formRefs,initialFormFieldSummaryTotals);  
        }

    }
    const mapSummaryTotals= (formRefs,formFieldSummaryTotals)=>{
        const fields = {
            InvoiceMTD: formFieldSummaryTotals.invoiceMTD,
            InvoiceYTD: formFieldSummaryTotals.invoiceYTD,
            InvoiceLTD: formFieldSummaryTotals.invoiceLTD,
            InvoicePriorY: formFieldSummaryTotals.invoicePriorY,
            PaymentMTD: formFieldSummaryTotals.paymentMTD,
            PaymentYTD: formFieldSummaryTotals.paymentYTD,
            PaymentLTD: formFieldSummaryTotals.paymentLTD,
            PaymentPriorY: formFieldSummaryTotals.paymentPriorY,
            DiscountMTD: formFieldSummaryTotals.discountMTD,
            DiscountYTD: formFieldSummaryTotals.discountYTD,
            DiscountLTD: formFieldSummaryTotals.discountLTD,
            DiscountPriorY: formFieldSummaryTotals.discountPriorY,
            CreditMTD: formFieldSummaryTotals.creditMTD,
            CreditYTD: formFieldSummaryTotals.creditYTD,
            CreditLTD: formFieldSummaryTotals.creditLTD,
            CreditPriorY: formFieldSummaryTotals.creditPriorY,
            PaidMTD: formFieldSummaryTotals.paidMTD,
            PaidYTD: formFieldSummaryTotals.paidYTD,
            PaidLTD: formFieldSummaryTotals.paidLTD,
            PaidPriorY: formFieldSummaryTotals.paidPriorY,
            PaidDueDateMTD: formFieldSummaryTotals.paidDueDateMTD,
            PaidDueDateYTD: formFieldSummaryTotals.paidDueDateYTD,
            PaidDueDateLTD: formFieldSummaryTotals.paidDueDateLTD,
            PaidDueDatePriorY: formFieldSummaryTotals.paidDueDatePriorY,
            PostedMTD: formFieldSummaryTotals.postedMTD,
            PostedYTD: formFieldSummaryTotals.postedYTD,
            PostedLTD: formFieldSummaryTotals.postedLTD,
            PostedPriorY: formFieldSummaryTotals.postedPriorY,
            PaidLateMTD: formFieldSummaryTotals.paidLateMTD,
            PaidLateYTD: formFieldSummaryTotals.paidLateYTD,
            PaidLateLTD: formFieldSummaryTotals.paidLateLTD,
            PaidLatePriorY: formFieldSummaryTotals.paidLatePriorY,
            AvgDaysPayMTD: formFieldSummaryTotals.avgDaysPayMTD,
            AvgDaysPayYTD: formFieldSummaryTotals.avgDaysPayYTD,
            AvgDaysPayLTD: formFieldSummaryTotals.avgDaysPayLTD,
            AvgDaysPayPriorY: formFieldSummaryTotals.avgDaysPayPriorY,
            CurrentBalance: formFieldSummaryTotals.currentBalance,
            CustomerLASTSTATEMENTDATE:formFieldSummaryTotals.lastStmDate,
            CustomerLASTSTATEMENTBALANCE:formFieldSummaryTotals.lastStmBalance,
          };
          
          Object.entries(fields).forEach(([key, value]) => {
            if (formRefs.current[key]) {
              formRefs.current[key].instance().option('value', value);
              formRefs.current[key].instance().option('disabled', true);
            }
          });
    }
    const fetchSummaryTotalsData = async (id) => {
        try {
            const res = await axios.get(
              `${window._env_.REACT_APP_APIS}/id/Customer/GetSummaryTotals?customerId=${id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  access_token: accessToken,
                  Authorization: `Bearer ${accessToken}`
                }
              }
            );
            if (res.data) {
                return res.data;
              
            } else {
              console.warn("No companies data available.");
            }
        } catch (err) {
          console.log(err, "Error while getting databases");
        }
      };
      
    const loadLookupFromCodesDataSource = (formRefs,type, name) => {
            const dataSource = GetCodeByType(type);
            if (formRefs.current[name]) {
                formRefs.current[name].instance().option('dataSource', dataSource);
                formRefs.current[name].instance().option('valueExpr', 'name');
                formRefs.current[name].instance().option('displayExpr', 'name');
                formRefs.current[name].instance().option('value', formFields[name]);
            }
    };    
    const GetCodeByType = (type) => {
            const items = new DataSource({
                store: createStore({
                    loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
                    key: 'name',
                    loadParams: {
                        codeType: type,
                    },
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                sort: [{ selector: "name", desc: false }],
                paginate: true,
                pageSize: 100
            });
            return items;
    };
    const loadLookupFromStaticData = (formRefs,name,dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if(formFields[name])
            formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    const loadLookupFromDataSource = (formRefs,name, url,valueExpr,displayExpr,loadParams=null) => {
          var dataSource = new DataSource({
              store: new createStore({
                  key: valueExpr,
                  loadUrl: url,
                  loadParams:loadParams,
                  onBeforeSend: function (method, ajaxOptions) {
                      ajaxOptions.headers = {
                          Authorization: `Bearer ${accessToken}`
                      };
                  }
              }),
              sort: [{ selector: displayExpr, desc: false }],
              paginate: true,
              pageSize: 100
          });
          if (formRefs.current[name]) {
              formRefs.current[name].instance().option('dataSource', dataSource);
              formRefs.current[name].instance().option('valueExpr', valueExpr);
              formRefs.current[name].instance().option('displayExpr', displayExpr);
              if(formFields[name])
              formRefs.current[name].instance().option('value', formFields[name]);
          }
    };

    const oMDefaultsSelectionChanged = (formRefs, name, value,text=null,formatCaption=null,chargeuom=null) => {
        const frmOMR0000 = {
            module: 'frmOMR0000',
        };
        const frmOMR0001 = {
            module: 'frmOMR0001',
        };
        const frmOMR0002 = {
            module: 'frmOMR0002',
        };
        if (name == 'CustomerOMPICKINGSLIPREPORTTYPE' && value != null) {
            if (value === 'A') {
                if (formRefs.current['PickSlipFormat']) { formRefs.current['PickSlipFormat'].instance().option('disabled', true); }
            }
            else if (value === 'B') {
                if (formRefs.current['PickSlipFormat']) { formRefs.current['PickSlipFormat'].instance().option('disabled', false); }
                loadLookupFromDataSource(formRefs, "PickSlipFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name',frmOMR0002);
            }
            else if (value === 'C') {
                if (formRefs.current['PickSlipFormat']) { formRefs.current['PickSlipFormat'].instance().option('disabled', false); }
                loadLookupFromDataSource(formRefs, "PickSlipFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`, 'id', 'name',frmOMR0002);
            }
        }
        if (name == 'CustomerOMINVOICEREPORTTYPE' && value != null) {
            if (value === 'A') {
                if (formRefs.current['InvoiceFormat']) { formRefs.current['InvoiceFormat'].instance().option('disabled', true); }
            }
            else if (value === 'B') {
                if (formRefs.current['InvoiceFormat']) { formRefs.current['InvoiceFormat'].instance().option('disabled', false); }
                loadLookupFromDataSource(formRefs, "InvoiceFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name',frmOMR0001);
            }
            else if (value === 'C') {
                if (formRefs.current['InvoiceFormat']) { formRefs.current['InvoiceFormat'].instance().option('disabled', false); }
                loadLookupFromDataSource(formRefs, "InvoiceFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`, 'id', 'name',frmOMR0001);
            }
        }
        if (name == 'CustomerOMORDERACKNREPORTTYPE' && value != null) {
            if (value === 'A') {
                if (formRefs.current['OrderAcknFormat']) { formRefs.current['OrderAcknFormat'].instance().option('disabled', true); }
            }
            else if (value === 'B') {
                if (formRefs.current['OrderAcknFormat']) { formRefs.current['OrderAcknFormat'].instance().option('disabled', false); }
                loadLookupFromDataSource(formRefs, "OrderAcknFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name',frmOMR0000);
            }
            else if (value === 'C') {
                if (formRefs.current['OrderAcknFormat']) { formRefs.current['OrderAcknFormat'].instance().option('disabled', false); }
                loadLookupFromDataSource(formRefs, "OrderAcknFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`, 'id', 'name',frmOMR0000);
            }
        }
        if (name == 'CustomerDISCOUNTTYPE' && value != null) {
            if (value === 'D') {
                if (formRefs.current['CustomerR_DISCOUNTTABLE']) { formRefs.current['CustomerR_DISCOUNTTABLE'].instance().option('disabled', false);}
            }
            else{
                if (formRefs.current['CustomerR_DISCOUNTTABLE']) { formRefs.current['CustomerR_DISCOUNTTABLE'].instance().option('disabled', true);}
            }
        }
//-----------------------------------///

        if (text != null && text!=='' && formatCaption!==null) {
            let format= `${chargeuom}||${text}||${formatCaption}`;
            if (name == 'PickSlipFormat'){
                setReportFormats(prevFields => ({
                ...prevFields,
                pickingSlipFormat:format,
               }
               ));
            }
            if (name == 'InvoiceFormat'){
                setReportFormats(prevFields => ({
                ...prevFields,
                InvoiceFormat:format,
               }
               ));
            }
            if (name == 'OrderAcknFormat'){
                setReportFormats(prevFields => ({
                ...prevFields,
                OrderAcknFormat:format,
               }
               ));
            }

        }
    }

    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };


    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.ID.DeleteCustomerDataEntry}`, formFields.ROWID, {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
                if (!response.data.ERRORS.length > 0) {
                    notify(
                        {
                            message: "Customer Deleted",
                            width: 100,
                        },
                        'success',
                        3000,
                    );
                    setLoadPanelVisible(false);
                    history.push('/wm/codes/customer-data-entry');
                } else {
                    setLoadPanelVisible(false);
                    const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
            }
        })
    }
    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        setformFieldSummaryTotals(initialFormFieldSummaryTotals);
        skipDataLoading = false;
        history.push('/wm/codes/add-customer');
        EnableControlsForNewRecord();
    }


    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                console.log(responseData);
                if (responseData.ROWID) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (formRefs.current["R_PROFILE"]) {
                        formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                }
                else {
                    console.error('Failed to get transaction data');
                }
            });


        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };



    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }else{
            const typedText = props.typeText;
            if (typedText && !props.isEdit) {
                setformFields(prevFields => ({
                    ...prevFields,
                    IDENTITYID: typedText,
                }));
                
            } 
            else{
                if(props.typeText)
                  GetHeaderInfoById(props.typeText); 
            } 
        }
    }, [ props.id,props.typeText]);

    const goBack = () => {
        const typedText = props.typeText;
        if (typedText) {
            history.goBack();  
        } else {
            history.push("/wm/codes/customer-data-entry");
        }
     };

    const EnableControlsForNewRecord = () => {

        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', false);
        }

        if (formRefs.current["R_CUSTOMER"]) {
            formRefs.current["R_CUSTOMER"].instance().option('disabled', false);
        }

        if (formRefs.current["TRANSACTIONTYPE"]) {
            formRefs.current["TRANSACTIONTYPE"].instance().option('disabled', false);
        }
    }

    const GetCustomerDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerByProfileRowId?rowid=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                if (response.data) {
                    setformFields(response.data);
                }
            }
            else {
                console.error('Failed to get transaction profile data');
            }
        } catch (error) {
            console.error('Error fetching transaction profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
        const handleFieldChange = useCallback((name, value, e) => {
            if (name == "R_PROFILE" && !skipDataLoading) {
                GetCustomerDataFromProfile(value);
            }
        });
        const getFormats=()=>{ 
            let SReport = '';
            if(reportFormats.pickingSlipFormat!==''){
                if(formFields.CustomerOMPICKINGSLIPREPORTTYPE==='C'){
                   let f= reportFormats.pickingSlipFormat.split('||');
                   SReport +=f[2]+ '\r\n';
                }
                else{
                    SReport += reportFormats.pickingSlipFormat + '\r\n';
                }
            }
            else{
                SReport += '\r\n';
            }
            if(reportFormats.InvoiceFormat!==''){
                if(formFields.CustomerOMINVOICEREPORTTYPE==='C'){
                    let f= reportFormats.InvoiceFormat.split('||');
                    SReport +=f[2]+ '\r\n';
                 }
                 else{
                     SReport += reportFormats.InvoiceFormat + '\r\n';
                 }
            }
            else{
                SReport += '\r\n';
            }
            if(reportFormats.OrderAcknFormat!==''){
                if(formFields.CustomerOMORDERACKNREPORTTYPE==='C'){
                    let f= reportFormats.OrderAcknFormat.split('||');
                    SReport +=f[2]+ '\r\n';
                 }
                 else{
                     SReport += reportFormats.OrderAcknFormat + '\r\n';
                 }
            }
            return SReport;
        }
        
    function extractNames(formRefs) {
        let sReport = formFields.CustomerOMDEFAULTREPORTFORMATS;
        if(sReport !==null){
            const reportLines = sReport.split('\r\n').filter(Boolean);
            const cleanedReportLines = reportLines.map(line => {
                const parts = line.split('||');
                return parts.length === 3 ? parts[1] : line;
               });
               const standardPickSlip = [
                { id: uuidv4(), name: 'Standard Abecas Item W/Location', description: 'rptStandardAbecasItemLocation' },
                { id: uuidv4(), name: 'Standard Abecas Item Lot W/Location', description: 'rptStrdAbecasItemLotLocation' },
                { id: uuidv4(), name: 'Standard Abecas Item W/No Location', description: 'rptStandardAbecasItem' },
                { id: uuidv4(), name: 'Standard Abecas Item Lot W/No Location', description: 'rptStandardAbecasItemLot' },
                { id: uuidv4(), name: 'Standard Abecas ItemLot OrderBy Location', description: 'rptStdByLocation' }
              ];
              const standardInvoice = [
                { id: uuidv4(), name: 'Standard Abecas', description: 'rptInvoice' },
                { id: uuidv4(), name: 'Standard Abecas with No Headings', description: 'rptDotMatrix1Invoice' },
                { id: uuidv4(), name: 'Standard Abecas with Price Schedule', description: 'rptInvoice_PSched' },
                { id: uuidv4(), name: 'Standard Abecas by Item', description: 'rptInvoice_ByItem' },
                { id: uuidv4(), name: 'Standard Abecas with Component Codes', description: 'rptInvoiceRebates' }
              ];
              const standardOrdAck = [
                { id: uuidv4(), name: 'Standard Abecas', description: 'rptOrderAcknowledgement' },
                { id: uuidv4(), name: 'McKay Format', description: 'rptMcKayNursery' },
                { id: uuidv4(), name: 'Standard Lot Format', description: 'rptOrderLotAck' }
              ];
               setSelectBoxValueByDisplay(formRefs,'PickSlipFormat', (cleanedReportLines[0] || "").replace(":ABR0001", "").trim(),standardPickSlip);
               setSelectBoxValueByDisplay(formRefs,'InvoiceFormat', (cleanedReportLines[1] || "").replace(":ABR0001", "").trim(),standardInvoice);
               setSelectBoxValueByDisplay(formRefs,'OrderAcknFormat', (cleanedReportLines[2] || "").replace(":ABR0001", "").trim(),standardOrdAck);
        }
    }
    const setSelectBoxValueByDisplay = async (formRefs,refKey, displayValue,newItems=[]) => {
        const instance = formRefs?.current[refKey]?.instance;
        if (!instance || displayValue===null) return;
      
        const store = instance.option('dataSource');
        const displayExpr = instance.option('displayExpr');
        const valueExpr = instance.option('valueExpr');
      
        try {
          const existingData  = await store?.load();
          const updatedData = [...newItems, ...existingData || []];
          const newStore = new ArrayStore({
            key: 'id',
            data: updatedData,
          });
      
          // Set new store to the select box
          instance.option('dataSource', newStore);
          const matchedItem = updatedData.find(item => item[displayExpr] === displayValue);
          if (matchedItem) {
            instance.option('value', matchedItem[valueExpr]);
          } else {
            console.warn(`No match found for ${displayValue} in ${refKey}`);
          }
        } catch (error) {
          console.error(`Error loading store for ${refKey}`, error);
        }
      };
      const fetchCustomerFinanacialInfo = async (id) => {
        try {
            const res = await axios.get(
              `${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerFinancialInfo?rowid=${id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  access_token: accessToken,
                  Authorization: `Bearer ${accessToken}`
                }
              }
            );
            if (res.data) {
                return res.data;
              
            } else {
              console.warn("No companies data available.");
            }
        } catch (err) {
          console.log(err, "Error while getting databases");
        }
      };
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) =>{e.stopPropagation(); handleFormSubmit(e)}} >
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Customer Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" disabled={props.typeText!==null && props.typeText!==undefined && props.typeText!==''} />
                                </Item>
                            </Toolbar>
                                <TabPanel deferRendering={(props.id || props.isEdit)?true:false}  showNavButtons={true} height={"auto"}>
                                    <TabItem title="Primary">
                                        <HeaderFrom formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} primaryFormLookupsLoad={primaryFormLookupsLoad}  IdType={IdType}/>
                                    </TabItem>
                                    <TabItem title="Def Address" >
                                        <AddressTab formFields={formFields} setformFields={setformFields} />
                                    </TabItem>
                                    <TabItem title="Alternate Address" >
                                        <AlternateAddressTab formFields={formFields} setformFields={setformFields} IdType={IdType} />
                                    </TabItem>
                                    <TabItem title="Additional">
                                        <AdditionalTab formFields={formFields} setformFields={setformFields} AdditionalForm={additionalFormLookupsLoad}/>
                                    </TabItem>
                                    <TabItem title="User Defined">
                                        <UserDefinedTab formFields={formFields} setformFields={setformFields} userDefinedFormLookupsLoad={userDefinedFormLookupsLoad}/>
                                    </TabItem>
                                    <TabItem title="WM Defaults">
                                        <WMDefaultsTab formFields={formFields} setformFields={setformFields} wmDefaultsFormLookupsLoad={wmDefaultsFormLookupsLoad}/>
                                    </TabItem>
                                    <TabItem title="OM Defaults">
                                        <OMDefaultsTab formFields={formFields} setformFields={setformFields} omDefaultsFormLookupsLoad={omDefaultsFormLookupsLoad} oMDefaultsSelectionChanged={oMDefaultsSelectionChanged}/>
                                    </TabItem>
                                    <TabItem title="FM Defaults" >
                                        <FMDefaultsTab formFields={formFields} setformFields={setformFields} fmDefaultsFormLookupsLoad={fmDefaultsFormLookupsLoad}/>
                                    </TabItem>
                                    <TabItem title="Credit">
                                        <CreditTab formFields={formFields} setformFields={setformFields} creditFormLookupsLoad ={creditFormLookupsLoad}/>
                                    </TabItem>
                                    <TabItem title="Summary" >
                                        <SummaryTab formFields={formFieldSummaryTotals} setformFields={setformFieldSummaryTotals} summaryFormLoaded={summaryFormLoaded}/>
                                    </TabItem>
                                    <TabItem title="History"  >
                                        <HistoryTab formFields={customerFinancialInfo} setformFields={setCustomerFinancialInfo} historyFormLoaded ={historyFormLoaded}/>
                                    </TabItem>
                                    <TabItem title="Currency" >
                                    </TabItem>
                                    <TabItem title="Contact" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="Contact"
                                        gridKey='78664084-EBFB-4BE2-8FB7-F4091616E206'/>
                                    </TabItem>
                                    <TabItem title="All Contacts" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="AllContacts" 
                                         gridKey='E274C971-ED4D-4906-8FB1-ABE714EFF639'/>
                                    </TabItem>
                                    <TabItem title="Consignee/Ship To" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'} >
                                        <RelationshipLinkList gridKey="9e898ba0-3c1a-49d2-a4ff-1e821ad51eba" formFields={formFields} IdMemberType="02" IdMasterType={IdType} LookupUrl="id/Lookup/GetConsignees" Editable={true}></RelationshipLinkList>
                                    </TabItem>
                                    <TabItem title="Participant/Salesperson" >
                                        <RelationshipLinkList gridKey="9a46baf9-bb2d-439e-8a20-d7a4ba97926c" formFields={formFields} IdMemberType="14" IdMasterType={IdType} LookupUrl="id/Lookup/GetParticipants" Editable={true}></RelationshipLinkList>
                                    </TabItem>
                                    <TabItem title="Agent" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'} >
                                        <RelationshipLinkList gridKey="36b86e8f-6bbd-4c5e-96c1-954b72669a8e" formFields={formFields} IdMemberType="07" IdMasterType={IdType} LookupUrl="id/Lookup/GetAgents" Editable={true}></RelationshipLinkList>
                                    </TabItem>
                                    <TabItem title="Shipper" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'} >
                                        <RelationshipLinkList gridKey="78ec5d1c-95f0-4eb7-96b5-18d396d4256c" formFields={formFields} IdMemberType="03" IdMasterType={IdType} LookupUrl="id/Lookup/GetShippers" Editable={true}></RelationshipLinkList>
                                    </TabItem>
                                    <TabItem title="Customer" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <RelationshipLinkList  gridKey="5B852C11-197E-47B7-A75E-2A62FA1510E7" formFields={formFields} IdMemberType={IdType} IdMasterType={IdType} LookupUrl="id/Lookup/GetCustomers" Editable={true}></RelationshipLinkList>
                                    </TabItem>
                                    <TabItem title="Synonyms" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <Synonym  gridKey="dc769e62-70f6-4af9-8a21-1c297c424696" formFields={formFields} IdType={IdType}></Synonym>
                                    </TabItem>
                                </TabPanel>
                                <div className="row">
                                 <ValidationSummary className="pl-3 pt-1" id="summary" />
                               </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(MainTab);
